import { Col, Form, Row, Select, Spin } from "antd";
import "antd/dist/antd.min.css";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { getRequest, patchRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import InputField from "../../common/htmlComponents/InputField";
import "../../styles/Main.scss";
import { authUserData } from "../../utils/Helper";
import { SuccessNotificationMsg } from "../../utils/Notifications";

const { Option } = Select;

const AddSuburb = ({ handleCancel, setReload, suburbId, modalKey }) => {
  const { t } = useTranslation();
  const formRef = useRef();
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setApiLoading] = useState(false);

  const initialState = {
    country: authUserData()?.country ? authUserData()?.country : 1,
    state: authUserData()?.state ? authUserData()?.state : 1,
    area: "",
    zone: null,
  };

  const [state, setState] = useState(initialState);
  const [states, setStates] = useState([]);
  const [countryName, setCountryName] = useState();
  const [zones, setZones] = useState([]);
  useEffect(() => {
    getCountryName();
    authUserData()?.country
      ? getStateByCountry(authUserData()?.country)
      : getStateByCountry(1);
    authUserData()?.state
      ? getZoneByState(authUserData()?.state)
      : getZoneByState(1);
  }, []);
  useEffect(() => {
    const fetchzoneById = async () => {
      if (suburbId !== null) {
        try {
          setApiLoading(true);
          const response = await getRequest(`suburb/${suburbId}/`);

          if (response.data.success) {
            const {
              id,
              country_name,
              state_name,
              zone_name,
              suburb_name,
              state_code,
              country_code,

              ...filteredResponse
            } = response.data.data;
            setState((prevState) => {
              return {
                ...filteredResponse,
              };
            });
            formRef.current.setFieldsValue({
              ...response?.data?.data,
              state: response?.data?.data.state_name,
              country: response?.data?.data.country_name,
              zone: response?.data?.data.zone_name,
              area: response?.data?.data.area,
            });
            getStateByCountry(response?.data?.data.country);
            getZoneByState(response?.data?.data.state);
            setApiLoading(false);
          } else {
            console.log("Error In API");
          }
        } catch (error) {
          setApiLoading(false);
        }
      }
    };
    if (suburbId !== null) {
      fetchzoneById();
    }
  }, [suburbId, modalKey]);

  const handleCountrySelectChange = (value) => {
    setState((prevState) => {
      return {
        ...prevState,
        country: value,
        state: null,
      };
    });
    formRef.current.setFieldsValue({ state: null });
    setStates([]);
    getStateByCountry(value);
  };
  const getStateByCountry = async (id) => {
    const stateResponse = await getRequest(
      "state/?no_pagination=true&country_id=" + id
    );

    setStates(stateResponse?.data?.data);
  };

  const getCountryName = async (data) => {
    await getRequest("country/?no_pagination=True", data).then((response) => {
      setCountryName(response?.data?.data);
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleZoneChange = (value) => {
    setState((prevState) => ({
      ...prevState,
      zone: value,
    }));
  };

  const handleStateSelectChange = (value) => {
    setState((prevState) => ({
      ...prevState,
      state: value,
      zone: null,
    }));
    formRef.current.setFieldsValue({ zone: null });
    setZones([]);
    getZoneByState(value);
  };
  const getZoneByState = async (id) => {
    const zoneResponse = await getRequest(
      "zone/?no_pagination=true&state_id=" + id
    );

    setZones(zoneResponse?.data?.data);
  };
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        backToList();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  });
  const backToList = () => {
    setState(initialState);
    authUserData()?.state
      ? getZoneByState(authUserData()?.state)
      : getZoneByState(1);
    formRef?.current?.setFieldsValue(initialState);
    handleCancel();
  };

  const handleSubmit = async () => {
    try {
      setBtnLoading(true);
      let response;
      if (suburbId === null) {
        response = await postRequest("suburb/", state);
      } else {
        response = await patchRequest(`suburb/${suburbId}/`, state);
      }
      if (response.data.success) {
        SuccessNotificationMsg(
          suburbId === null
            ? t("suburb_added_successfully")
            : t("suburb_updated_successfully")
        );
        backToList();
        setReload((reload) => !reload);
      }
    } catch (error) {
      console.error("Error submitting suburb:", error);
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <>
      <Spin spinning={apiLoading}>
        <Form
          onFinish={handleSubmit}
          autoComplete="off"
          ref={formRef}
          initialValues={state}
        >
          <Row gutter={16}>
            <Col md={12} className="TextFeild">
              <Form.Item
                name="country"
                label={t("pl_country")}
                placeholder={t("pl_select_country")}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("val_country")}</Trans>,
                  },
                ]}
              >
                <Select
                  placeholder={t("pl_select_country")}
                  showArrow
                  showSearch
                  // allowClear
                  value={state?.country}
                  name="country"
                  optionFilterProp="children"
                  onChange={(value) => handleCountrySelectChange(value)}
                >
                  {countryName?.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col md={12} className="TextFeild">
              <Form.Item
                name="state"
                label={t("pl_state")}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("val_select_state")}</Trans>,
                  },
                ]}
              >
                <Select
                  name="state"
                  placeholder={t("pl_select_state")}
                  showArrow
                  showSearch
                  value={state?.state}
                  optionFilterProp="children"
                  onChange={handleStateSelectChange}
                >
                  {states.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col md={12} className="TextFeild">
              <Form.Item
                name="zone"
                label={t("zone")}
                // rules={[
                //   {
                //     required: true,
                //     message: <Trans>{t("val_select_zone")}</Trans>,
                //   },
                // ]}
              >
                <Select
                  name="zone"
                  label={t("zone")}
                  placeholder={t("pl_select_zone")}
                  onChange={handleZoneChange}
                  value={state?.zone}
                  showArrow
                  showSearch
                  optionFilterProp="children"
                >
                  {zones.map((zone) => (
                    <Option key={zone.id} value={zone.id}>
                      {zone.zone}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col md={12} className="TextFeild">
              <InputField
                name="area"
                label={t("pl_suburb")}
                placeholder={t("pl_enter_suburb")}
                rules={t("pl_enter_valid_subrub")}
                value={state.suburb} // Correct, using state.suburb
                handleInputChange={handleInputChange}
                pattern={"^[a-zA-Z0-9\\s]+$"}
                max={100}
              />
            </Col>
          </Row>

          <div className="ModalPopupFooter">
            <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              label={t("cancel")}
              onClick={backToList}
            />
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              label={t("save")}
              htmlType="submit"
              loading={btnLoading}
            />
          </div>
        </Form>
      </Spin>
    </>
  );
};

AddSuburb.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  setReload: PropTypes.func.isRequired,
  suburbId: PropTypes.number,
  modalKey: PropTypes.bool,
};

export default AddSuburb;
